import {Service} from "../Service";

export class EstatusMovimientoService extends Service{

    constructor() {
        super('estatusMovimiento/');
    }
}